<template lang="pug">
  #container
    .l_container(:style="{ overflowX: ($route.name === 'index') ? 'hidden' : '' }")
        the-header
        .l_contents
          router-view
        the-footer(v-if="$route.name === 'index' || !$store.state.isSmartPhone")
</template>

<script>
import TheFade from '@/components/TheFade'
import TheHeader from '@/components/TheHeader'
import TheFooter from '@/components/TheFooter'
export default {
  name: 'Container',
  components: {
    TheFade,
    TheHeader,
    TheFooter,
  },
  methods: {
  }
}
</script>

<style lang="scss">
@import './src/assets/css/_style.scss';
@import './src/assets/css/_c_heading.scss';

@if $fo_webfont != false {
  @font-face  {
    font-family: $fo_webfont;
    src: url("../static/font/#{$fo_webfont}.woff") format("woff"), url("../static/font/#{$fo_webfont}.woff2") format("woff2");
  }
}

@if $fo_webfont2 != false {
  @font-face  {
    font-family: $fo_webfont;
    src: url("../static/font/#{$fo_webfont}.woff") format("woff"), url("../static/font/#{$fo_webfont}.woff2") format("woff2");
  }
}

::selection {
  background: $palet3;
}

html {
  &.overflow {
    overflow: hidden;
    max-height: 100vh;
  }
}

body {
  height: 100%;
}

.l_container {
  @include pc {
    min-width: $min_l#{px};
  }
  @include fo_yugo();
  font-size: rem(14);
  width: 100%;
  min-width: $min_s#{px};
  min-height: 100%;
  margin: 0 auto;
  position: relative;
  // overflow-x: hidden;
  background: #fff;
  -webkit-text-size-adjust: 100%;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-feature-settings: "kern";
  -webkit-font-kerning: normal;
  -webkit-font-smoothing: antialiased;
  font-feature-settings: "kern";
  font-kerning: normal;
  padding: 1px 0 0;

  &::after {
    @include cf();
  }
}

.l_contents {
  @include pc {
    overflow: hidden;
  }
}

.main {
}

.slick {
  &-slider {
    overflow-x: hidden;
    position: static;
  }
  &-track {
    display: flex;
  }
}

</style>



// WEBPACK FOOTER //
// src/Container.vue